import IcDelete from '@deliveryhero/pd-cookbook/components/Icons/IcDelete';
import IcEdit from '@deliveryhero/pd-cookbook/components/Icons/IcEdit';
import { ListItemIcon, MenuItem } from '@mui/material';

import ActionMenu from 'src/components/ActionMenu';

import { EmployeeListingActionMenuProps } from './types';

export const EmployeeListingActionMenu = ({
  handleEdit,
  handleDelete
}: EmployeeListingActionMenuProps) => {
  return (
    <>
      <MenuItem onClick={handleEdit}>
        <ListItemIcon>
          <IcEdit />
        </ListItemIcon>
        Edit
      </MenuItem>
      <MenuItem onClick={handleDelete}>
        <ListItemIcon>
          <IcDelete />
        </ListItemIcon>
        Delete
      </MenuItem>
    </>
  );
};
